import React, { FC, PropsWithChildren } from 'react';
import { useI18nContext } from '@i18n/i18n-react';
import { Dash } from '@components/icons/FarseerIcons';
import { FlexColCentered } from '@components/layout/Flex';
import { Text } from '@components/typography/Typography';
import useTheme from '@base/useTheme';

export const DashboardEmpty: FC<object> = (props: PropsWithChildren<object>) => {
    const { LL } = useI18nContext();
    const theme = useTheme();

    return (
        <FlexColCentered>
            <Dash color={theme.colors.neutral.w700} />
            <Text $muted $bold>
                {LL.DASHBOARD_EMPTY()}
            </Text>
            <Text $muted style={{ maxWidth: 290, marginTop: 5, textAlign: 'center', lineHeight: '18px' }}>
                {LL.DASHBOARD_HINT()}
            </Text>
            <div style={{ marginTop: 20 }}>{props.children}</div>
        </FlexColCentered>
    );
};
